import React, { useState, useContext, useRef, useEffect, useCallback } from 'react'
import { Carousel } from 'react-responsive-carousel'
import { UserContext } from '../../context/UserContext'
import { LoadingCover } from '../commons/LoadingCover'
import { SystemError } from '../error/SystemError'
import Image from 'next/image'
import { s3Static } from '../../utils/constants'
import { uploadImage } from '../../api/user/post-api'
import "react-responsive-carousel/lib/styles/carousel.min.css"; // requires a loader
import { downloadCarousel } from '../../api/user/profile-api'

export const Timeline = (props) => {
    const stringsUserId = props.stringsUserId

    const file = useRef('')
    const inputFile = useRef(null);
    const storeKey = "timeline"

    const [ timeline, setTimeline ] = useState(props.timeline)
    const [ isLoading, setIsLoading ] = useState(false);
    const [ isSystemError, setIsSystemError ] = useState(false);
    const [ errorContent, setErrorContent ]  = useState({'header': "", 'body': ""});

    const { userId, userFullName,  } = useContext(UserContext)

    const downloadTimeline = useCallback(async() => {
        try {
            setTimeline(await downloadCarousel(stringsUserId))
        } catch (error) {
            console.log(error);
            setErrorContent({'header': "Error refreshing timeline", 'body': "Please try again. If problem persists, contact us at support@stringssg.com"});
            setIsSystemError(true);
            return;
        }
    }, [stringsUserId, setTimeline])

    const uploadTimelineImage = async() => {
        try {
            await uploadImage(file.current, userId, userFullName, "", "Carousel", "Public", "public", "")
            downloadTimeline()
        } catch (error) {
            console.log(error);
            setErrorContent({'header': "Error uploading timeline", 'body': "Please try again. If problem persists, contact us at support@stringssg.com"});
            setIsSystemError(true);
            return;
        }
    }

    useEffect(() => {
        if(!stringsUserId) return
        downloadTimeline()
    }, [stringsUserId, downloadTimeline])

    const handleFileChange =(e) => {
        if(e.target.files.length == 0) return;
        let files = e.target.files;
        file.current = files[files.length-1];        
        var reader = new FileReader();
        // reader.onload = (e) => {
        //     setBuzzFile(e.target.result);
        //     setIsShowFile(true);
        // }
        reader.readAsDataURL(file.current);
        if(file.current.size > 10485760){
            setErrorContent({'header': "File size exceeded", 'body': "Please try again with a file size less than 10MB."});
            setIsSystemError(true);
            return;
        } 
        uploadTimelineImage()        
    }   

  return (
    <>
        <div className=''>
            {timeline?.length > 0 ?  
                <Carousel autoPlay={true} infiniteLoop={true} showThumbs={false} showStatus={false}>
                    {[...timeline].map((images, j) =>
                        <div className='relative h-72 w-full' key={j}>    
                            <Image className=''
                                src={images.Image}
                                fill
                                sizes="(max-width: 768px) 100vw, 33vw"
                                style={{objectFit: 'cover'}}
                                placeholder='blur'
                                blurDataURL={s3Static + "placeholder.png"}
                                alt='Carousel image'
                            />     
                            <span className='absolute bottom-20 left-0 right-0'>
                                <span className='text-white'>{images.caption}</span>
                            </span>               
                        </div>                                                           
                    )}
                </Carousel>
                :
                <>
                    {userId === stringsUserId ? (               
                        <div className='relative h-28 w-full cursor-pointer' onClick={() => inputFile.current.click()}>    
                            <input className='hidden'
                                type="file" name="photo" aria-describedby="basic-addon5"
                                accept="image/*"
                                capture={false}
                                onChange={(e) => handleFileChange(e)}
                                ref={inputFile}
                            />
                            <Image className=''
                                src={s3Static + "default-timeline.jpg"}
                                fill
                                sizes="(max-width: 768px) 100vw, 33vw"
                                style={{objectFit: 'cover'}}
                                alt='Carousel image'
                            />         
                        </div>
                    ) : (
                        /* Default placeholder for other users without timeline - maintains space for ProfileHeader overlap */
                        <div className='relative h-28 w-full bg-linear-to-r from-orange-400 to-amber-400'>
                            <div className='absolute inset-0 bg-linear-to-b from-transparent to-black/10' />
                        </div>
                    )}
                </>
            }
        </div>
        {isLoading &&
            <LoadingCover/>
        }
        {isSystemError && <SystemError errorContent={errorContent} setIsSystemError={setIsSystemError}/>}
    </>
  )
}
